import "./LlePickupDetails.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
// import { CommonRegistrationSidebar } from "../../common/common-registration-sidebar/commonRegistrationSidebar";
import Grid from '@mui/material/Grid';
import { authKey, GET_CONSIGNMENT_DETAILS_BY_NUMBER, CONSIGNMENT_PICK_UP_CB_SAVE, TOLERANCE, CREATE_DELIVERY_CHALLAN, PRINT_DOWNLOAD_DATA, GET_STAKEHOLDER_CATEGORY, CONSIGNMENT_PICK_WEIGHT_MEASUREMENT, UPDATE_LOADING_FLAG, SEND_PLANT_GATE_PASS_NOTIFICATION, GET_CONFIGURATION_VALUES } from '../../../common/URLs';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { useLocation } from "react-router-dom";
import { Container, DialogContent, Dialog, DialogActions, Button, Box, TextField, Card, CardContent, Divider, FormHelperText } from '@mui/material';
import jwt from 'jwt-decode';
import HeapPopOver from "../chipping/heapPopover";
import Moment from 'moment';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD, PIT_ROLES, NO_DATA_AVAILABLE } from "../../../common/constants";
import { userData } from '../../../common/spinLoader';
import { Fab, Typography } from '@mui/material';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import Badge from 'react-bootstrap/Badge';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { toast } from "react-toastify";
import { VALIDATION, capitalizeFunction, weightValidation } from "../../../common/commonValidations";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import apiClient from "../../../axios";
import BundleSelection from "../sto/nstrBundleSelection";
import RBBundleSelection from "./rawBambooBundleSelection";

function LlePickUpDetails(props) {

  const userLoggedInRole = userData?.user?.userRoles?.[0]?.roleName;
  const checkDev = process.env.REACT_APP_ENV === "developement local" || process.env.REACT_APP_ENV === "developement" || process.env.REACT_APP_ENV === "test" || process.env.REACT_APP_ENV === "test local" || process.env.REACT_APP_ENV === "production"
  const roles = localStorage.getItem('role');
  const isWeighbridgeOperatorRole = [
    PIT_ROLES?.PitWeighbridgeOperator,
    PIT_ROLES?.PitManualWeighbridgeOperator
  ].includes(roles);
  const { state } = useLocation();
  const navigate = useNavigate();
  const decoded = jwt(getLocalStorageItem('id_token'));
  const [consignmentdetails, setConsignmentdetails] = useState();
  const [commentRows, setCommentRows] = useState([]);
  const [consignmentsource, setConsignmentsource] = useState();
  const [pickuprbcb, setPickuprbcb] = useState();
  const [consignmentPickupResponse, setConsignmentPickupResponse] = useState();
  const [chippingOrderList, setChippingOrderList] = useState([]);
  const [selectedHeap, setSelectedHeap] = useState([]);
  const [selectedBundles, setSelectedBundles] = useState([]);
  const [showGrid, setShowGrid] = useState(true);
  const [rbcbDetails, setRbcbDetails] = useState([]);
  const [newArrayList, setNewArrayList] = useState([]);
  const [pickupQuantity, setPickupQuantity] = useState('');
  const [computed, setComputed] = useState(false);
  const [totalWeightPickup, setTotalWeightPickup] = useState();
  const [createDeliveryChallan, setCreateDeliveryChallan] = useState();
  const ConsNumber = useLocation()?.state?.selectedConsNo;
  const [stakeholderDetails, setStakeholderDetails] = useState();
  const [getTolerance, setGetTolerance] = useState([]);
  const [minAvgMoisture, setMinAvgMoisture] = useState(0);
  const [maxAvgMoisture, setMaxAvgMoisture] = useState(0);
  const [downloadDeliveryChallan, setDownloadDeliveryChallan] = useState();
  const [characterLimit] = useState(500);
  const [addComment, setAddComment] = useState('');
  const [minimum, setMinimum] = useState();
  const [maximum, setMaximum] = useState();
  const [isApiCalled, setIsApiCalled] = useState(false);
  const [open, setOpen] = useState(false);

  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);
  const [logModalOpen1, setLogModalOpen1] = useState(false);
  const [logModalOpen2, setLogModalOpen2] = useState(false);
  const [logModalOpen4, setLogModalOpen4] = useState(false);
  const handleLogModalOpen1 = () => setLogModalOpen1(true);
  const handleLogModalClose1 = () => setLogModalOpen1(false);
  const handleLogModalOpen2 = () => setLogModalOpen2(true);
  const handleLogModalClose2 = () => setLogModalOpen2(false);
  const handleLogModalOpen4 = () => setLogModalOpen4(true);
  const handleLogModalClose4 = () => setLogModalOpen4(false);
  const [role1, setRole1] = useState(false);
  const [role2, setRole2] = useState(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const [confirmOpen2, setConfirmOpen2] = useState(false);
  const handleConfirmOpen2 = () => setConfirmOpen2(true);
  const handleConfirmClose2 = () => setConfirmOpen2(false);

  const [confirmOpen3, setConfirmOpen3] = useState(false);
  const handleConfirmOpen3 = () => setConfirmOpen3(true);
  const handleConfirmClose3 = () => setConfirmOpen3(false);

  const [confirmOpen4, setConfirmOpen4] = useState(false);
  const handleConfirmOpen4 = () => setConfirmOpen4(true);
  const handleConfirmClose4 = () => setConfirmOpen4(false);

  const [confirmOpen5, setConfirmOpen5] = useState(false);
  const handleConfirmOpen5 = () => setConfirmOpen5(true);
  const handleConfirmClose5 = () => setConfirmOpen5(false);

  const [confirmOpen6, setConfirmOpen6] = useState(false);
  const handleConfirmOpen6 = () => setConfirmOpen6(true);
  const handleConfirmClose6 = () => setConfirmOpen6(false);

  const [confirmOpen7, setConfirmOpen7] = useState(false);
  const handleConfirmOpen7 = () => setConfirmOpen7(true);
  const handleConfirmClose7 = () => setConfirmOpen7(false);

  const commentColumns = [
    { field: "action", headerName: "Action", width: 200 },
    {
      field: "comment", headerName: "Comment", width: 400,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
          {params.value}
        </div>
      ),
      valueGetter: (params) => params.value
    }
  ]

  const [consignmentNoDetails, setConsignmentNoDetails] = useState({
    "consignmentNo": useLocation()?.state?.selectedConsNo,
    "pickupTareWeight": "",
    "totalMoisture": "",
    "pickupAvgChipSize": "",
    "pickupGrossWeight": "",
    "pickupNetWeight": "",
    "totalWeight": "",
    "odometerReading": "",
    "isHitInspectionChecklist": "",
    "isProperLashing": "",
    "isPayloadWithinCapacity": "",
    "isPayloadHeightExceedLimit": "",
    "isTripStarted": "",
    "isLoadingCompleted": "",
    "pickupComments": "",
  });
  const [errorMessage, setErrorMessage] = useState({
    consignmentNoError: "",
    "pickupTareWeightError": "",
    "totalMoistureError": "",
    "pickupAvgChipSizeError": "",
    "pickupGrossWeightError": "",
    "pickupNetWeightError": "",
    "totalWeightError": "",
    "odometerReadingError": "",
    "isHitInspectionChecklistError": "",
    "isProperLashingError": "",
    "isPayloadWithinCapacityError": "",
    "isPayloadHeightExceedLimitError": "",
    "isTripStartedError": "",
    "heapError": "",
    "bundleError": "",
    "weightError": ""
    // "comments": ""  
  });

  // const pickupNetWeight = consignmentdetails?.pickupGrossWeight ? (Number((consignmentNoDetails?.pickupGrossWeight) - (consignmentNoDetails?.pickupTareWeight)) / 1000).toFixed(4) : null;
  const pickupNetWeight = consignmentdetails?.pickupGrossWeight ? (Number(consignmentNoDetails?.pickupGrossWeight) - (consignmentNoDetails?.pickupTareWeight)).toFixed(4) : null;

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   const role = getLocalStorageItem("role");

  //   const isPitOperator = role === PIT_ROLES.PitWeighbridgeOperator;
  //   const isAllowedField = name === "pickupTareWeight" || name === "pickupGrossWeight";
  //   if (checkDev && isPitOperator && isAllowedField) {
  //     // if (acceptingInput) {
  //     if (weightValidation(value)) {
  //       setConsignmentNoDetails({ ...consignmentNoDetails, [name]: value });
  //       setConsignmentdetails({ ...consignmentdetails, [name]: value });
  //     }
  //     // }
  //   } else {
  //     // Allow regular field updates for non-PitOperator roles
  //     if (weightValidation(value)) {
  //       setConsignmentNoDetails({ ...consignmentNoDetails, [name]: value });
  //       setConsignmentdetails({ ...consignmentdetails, [name]: value });
  //     }
  //   }
  //   // if (e.target.value.length > e.target.maxLength)
  //   //   e.target.value = e.target.value.slice(0, e.target.maxLength);
  //   setErrorMessage();
  //   // if (e.target.name === "consignmentNo") {
  //   //   setErrorMessage({ ...errorMessage, consignmentNoError: "" });
  //   // }
  //   if (e.target.name === "odometerReading") {
  //     setErrorMessage({ ...errorMessage, odometerReadingError: "" });
  //   }
  //   if (e.target.name === "pickupTareWeight") {

  //     setErrorMessage({ ...errorMessage, pickupTareWeightError: "" });
  //   }
  //   if (e.target.name === "totalMoisture") {
  //     setErrorMessage({ ...errorMessage, totalMoistureError: "" });
  //   }
  //   if (e.target.name === "pickupAvgChipSize") {
  //     setErrorMessage({ ...errorMessage, pickupAvgChipSizeError: "" });
  //   }
  //   if (e.target.name === "pickupGrossWeight") {
  //     setErrorMessage({ ...errorMessage, pickupGrossWeightError: "" });
  //   }
  //   if (e.target.name === "pickupNetWeight") {
  //     setErrorMessage({ ...errorMessage, pickupNetWeightError: "" });
  //   }
  //   if (e.target.name === "chippingOrderNo") {
  //     setErrorMessage({ ...errorMessage, chippingOrderNoError: "" });
  //   }
  //   // if (e.target.name === "pickupComments") {
  //   //   setErrorMessage({ ...errorMessage, pickupCommentsError: "" });
  //   // }
  //   if (pickupNetWeight === totalPickupWeight) {
  //     setErrorMessage({ ...errorMessage, weightError: "" })
  //   }

  // }

  useEffect(() => {
    console.log("Active element name:", document.activeElement?.name);
  }, [consignmentdetails?.isLoadingDone]);

  useEffect(() => {
    if (grossRef.current?.disabled && document.activeElement === grossRef.current) {
      grossRef.current.blur();
    }
  }, [
    !isWeighbridgeOperatorRole ||
    (isWeighbridgeOperatorRole &&
      consignmentdetails?.isPickupBundlesSelected &&
      !consignmentdetails?.isLoadingDone)
  ]);

  const tareRef = useRef(null);
  const grossRef = useRef(null);

  useEffect(() => {
    const role = getLocalStorageItem("role");
    const isPitOperator = role === PIT_ROLES?.PitWeighbridgeOperator;
    if (!isPitOperator) return;

    const isLoadingDone = !!consignmentdetails?.isLoadingDone;

    //  clear any existing focus first (IMPORTANT)
    if (document.activeElement === grossRef.current) grossRef.current.blur();
    if (document.activeElement === tareRef.current) tareRef.current.blur();

    //  focus the correct field only if it's enabled
    setTimeout(() => {
      if (!isLoadingDone) {
        if (tareRef.current && !tareRef.current.disabled) tareRef.current.focus();
      } else {
        if (grossRef.current && !grossRef.current.disabled) grossRef.current.focus();
      }
    }, 0);
  }, [consignmentdetails?.isLoadingDone]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (weightValidation(value)) {
      setConsignmentNoDetails((prev) => ({ ...prev, [name]: value }));
      setConsignmentdetails((prev) => ({ ...prev, [name]: value }));
    }

    setErrorMessage();

    if (name === "odometerReading") setErrorMessage((prev) => ({ ...prev, odometerReadingError: "" }));
    if (name === "pickupTareWeight") setErrorMessage((prev) => ({ ...prev, pickupTareWeightError: "" }));
    if (name === "totalMoisture") setErrorMessage((prev) => ({ ...prev, totalMoistureError: "" }));
    if (name === "pickupAvgChipSize") setErrorMessage((prev) => ({ ...prev, pickupAvgChipSizeError: "" }));
    if (name === "pickupGrossWeight") setErrorMessage((prev) => ({ ...prev, pickupGrossWeightError: "" }));
    if (name === "pickupNetWeight") setErrorMessage((prev) => ({ ...prev, pickupNetWeightError: "" }));
    if (name === "chippingOrderNo") setErrorMessage((prev) => ({ ...prev, chippingOrderNoError: "" }));

    if (pickupNetWeight === totalPickupWeight) {
      setErrorMessage((prev) => ({ ...prev, weightError: "" }));
    }
  };
  const onTextValueChange = (e) => {
    setAddComment(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 500)));
  }

  const radioChange = (e, value) => {
    setConsignmentNoDetails({
      ...consignmentNoDetails, [e.target.name]: value,
    })
    if (e.target.name === "isHitInspectionChecklist") {
      setErrorMessage({ ...errorMessage, isHitInspectionChecklistError: "" });
    }
    if (e.target.name === "isProperLashing") {
      setErrorMessage({ ...errorMessage, isProperLashingError: "" });
    }
    if (e.target.name === "isPayloadWithinCapacity") {
      setErrorMessage({ ...errorMessage, isPayloadWithinCapacityError: "" });
    }
    if (e.target.name === "isPayloadHeightExceedLimit") {
      setErrorMessage({ ...errorMessage, isPayloadHeightExceedLimitError: "" });
    }

  };

  useEffect(() => {
    if (ConsNumber) {
      getConsignmentDetails();
    }
  }, [ConsNumber]);

  useEffect(() => {
    if (userLoggedInRole) {
      if (userLoggedInRole === PIT_ROLES.ProcessingIncharge) {
        setRole1(true);
      }
      if (userLoggedInRole === PIT_ROLES.ProcessingIncharge) {
        setRole2(true);
      }
    }
  })

  useEffect(() => {
    if (consignmentPickupResponse) {
      if (consignmentPickupResponse.isSuccess === true) {
        toast.success(consignmentPickupResponse?.message);
      }
      else {
        toast.error(consignmentPickupResponse?.message ? consignmentPickupResponse?.message : "Error")
      }
      // navigate('/dashboardHome/dashboardStakeHolder')
    }
  }, [consignmentPickupResponse]);

  const getDetails = (e) => {
    e.preventDefault();
    if (!consignmentNoDetails.consignmentNo) {
      setErrorMessage({ ...errorMessage, consignmentNoError: "Please Enter Consignment Number" })
    }
    else {
      getConsignmentDetails();
    }
  }

  const getConsignmentDetails = () => {

    if (ConsNumber != "") {
      loaderService.showLoader();
      apiClient
        .post(GET_CONSIGNMENT_DETAILS_BY_NUMBER,
          {
            "consignmentNumber": ConsNumber,
          },
          {
            headers: {
              Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            }
          }, null
        )
        .then((response) => {
          setConsignmentdetails(response.data);
          setCommentRows([
            { action: "Consignment Creation", comment: response.data.consignmentComments, isValueThere: response.data.consignmentComments ? true : false },
            { action: "Pick-up", comment: response.data.pickupComments, isValueThere: response.data.pickupComments ? true : false },
            { action: "Pickup-Measurement", comment: response.data.pickupMeasurementComments, isValueThere: response.data.pickupMeasurementComments ? true : false },
            { action: "Loading", comment: response.data.loaderComments, isValueThere: response.data.loaderComments ? true : false },
            { action: "DeliveryChallan Creation", comment: response.data.deliveryChallanComments, isValueThere: response.data.deliveryChallanComments ? true : false },
            { action: "Trip Start", comment: response.data.tripStartComments, isValueThere: response.data.tripStartComments ? true : false },
            { action: "Measurement", comment: response.data.measurementComments, isValueThere: response.data.measurementComments ? true : false },
            { action: "Unloading", comment: response.data.unloaderComments, isValueThere: response.data.unloaderComments ? true : false },
            { action: "Generate GRN", comment: response.data.destinationComments, isValueThere: response.data.destinationComments ? true : false }
          ]);
          setConsignmentNoDetails({
            ...consignmentNoDetails,
            "odometerReading": response.data.consignmentMilestones?.[0]?.odometerReading,
            "pickupTareWeight": response.data.pickupTareWeight ? Number(Number(response.data.pickupTareWeight) * 1000).toFixed(4) : "",
            "totalMoisture": response.data.totalMoisture,
            "pickupAvgChipSize": response.data.pickupAvgChipSize,
            "pickupGrossWeight": response.data.pickupGrossWeight ? Number(Number(response.data.pickupGrossWeight) * 1000).toFixed(4) : "",
            "pickupNetWeight": response.data.pickupNetWeight,
            "totalWeight": response.data.totalWeight ? Number(response.data.totalWeight) * 1000 : '',
            "isHitInspectionChecklist": response.data.consignmentSourceDetails[0].isHitInspectionChecklist,
            "isProperLashing": response.data.consignmentSourceDetails[0].isProperLashing,
            "isPayloadWithinCapacity": response.data.consignmentSourceDetails[0].isPayloadWithinCapacity,
            "isPayloadHeightExceedLimit": response.data.consignmentSourceDetails[0].isPayloadHeightExceedLimit,
            "isTripStarted": response.data.isTripStarted,
            "isLoadingCompleted": response.data.isLoadingCompleted,
            "cbPickupList": response.data.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs,
          })
          isWeighbridgeOperatorRole && setAddComment(response.data?.pickupMeasurementComments);
          setConsignmentsource(response.data.consignmentSourceDetails[0]);
          setRbcbDetails(response.data.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs);
          if (response.data.materialType === "RawBamboo") {
            setSelectedBundles(response.data.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs);
          }
          if (response.data.materialType === "ChipBamboo") {
            setNewArrayList(response.data.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs);
          }
          loaderService.hideLoader();
        })
        .catch(function (error) {
          console.log(error);
          loaderService.hideLoader();
        });
    }
  }

  const totalPickupWeight = Number(selectedHeap?.reduce((accum, heap) => Number(accum) + Number(heap.rbCbWeight), consignmentNoDetails?.pickupNetWeight));

  const calculateAverageMoisture = (selectedBundles) => {
    if (!selectedBundles || selectedBundles.length === 0) return 0;

    const moistureValues = selectedBundles.map(item => item.moisture).filter(val => typeof val === 'number'); // safety check

    if (moistureValues.length === 0) return 0;

    const sum = moistureValues.reduce((acc, val) => acc + val, 0);
    return (sum / moistureValues.length).toFixed(2);
  };

  const totalMoistureRB = calculateAverageMoisture(selectedBundles);


  const consignment_pickup_cb_save = (tripStarted, loadingDone) => {
    loaderService.showLoader();
    apiClient
      .post(
        CONSIGNMENT_PICK_UP_CB_SAVE,
        {
          "consignmentNo": consignmentNoDetails?.consignmentNo,
          // "pickupTareWeight": consignmentNoDetails?.pickupTareWeight,
          "totalMoisture": consignmentdetails?.materialType === "RawBamboo" ? totalMoistureRB : consignmentdetails?.materialType === "ChipBamboo" ? consignmentNoDetails?.totalMoisture : null,
          "pickupAvgChipSize": consignmentNoDetails?.pickupAvgChipSize,
          // "pickupGrossWeight": consignmentNoDetails?.pickupGrossWeight,
          // "pickupNetWeight": totalPickupWeight,
          // "totalWeight": totalWeight,
          // "pickupNetWeight": consignmentNoDetails?.pickupNetWeight ? consignmentNoDetails?.pickupNetWeight : (consignmentNoDetails?.pickupNetWeight) + Number(totalPickupWeight),           
          "totalWeight": consignmentdetails?.materialType === "RawBamboo" ? pickupQuantity : consignmentdetails?.materialType === "ChipBamboo" ? Number(totalPickupWeight) : null,
          "odometerReading": consignmentNoDetails?.odometerReading,
          "isInspectionChecklist": consignmentNoDetails?.isHitInspectionChecklist,
          "isProperLashing": consignmentNoDetails?.isProperLashing,
          "isPayloadWithinCapacity": consignmentNoDetails?.isPayloadWithinCapacity,
          "isPayloadHeightExceedLimit": consignmentNoDetails?.isPayloadHeightExceedLimit,
          "isTripStarted": tripStarted,
          // "isLoadingDone": loadingDone,
          "comments": addComment,
          "isPickupBundlesSelected": true,
          "cbPickupList": consignmentdetails?.materialType === "RawBamboo" ? selectedBundles : consignmentdetails?.materialType === "ChipBamboo" ? [
            ...newArrayList
          ] : []
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setConsignmentdetails(response.data);
        setRbcbDetails(consignmentdetails?.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs);
        setConsignmentPickupResponse(response.data);
        getConsignmentDetails();
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  };

  const consignment_pickup_save_measurement = () => {
    const grossDisable = !isWeighbridgeOperatorRole || (isWeighbridgeOperatorRole && consignmentdetails?.isPickupBundlesSelected && !consignmentdetails?.isLoadingDone)
    const tareDisable = !isWeighbridgeOperatorRole || (isWeighbridgeOperatorRole && consignmentdetails?.isPickupBundlesSelected && consignmentdetails?.isLoadingDone)
    loaderService.showLoader();
    apiClient
      .post(
        CONSIGNMENT_PICK_WEIGHT_MEASUREMENT,
        {
          "consignmentNo": consignmentNoDetails?.consignmentNo,
          "pickupTareWeight": consignmentNoDetails?.pickupTareWeight
            ? Math.trunc(Number(consignmentNoDetails.pickupTareWeight) / 1000 * 10000) / 10000
            : null,
          "totalMoisture": consignmentNoDetails?.totalMoisture,
          "pickupGrossWeight": consignmentNoDetails?.pickupGrossWeight
            ? Math.trunc(Number(consignmentNoDetails.pickupGrossWeight) / 1000 * 10000) / 10000
            : null,
          "pickupNetWeight": pickupNetWeight ? Math.trunc(Number(pickupNetWeight) / 1000 * 10000) / 10000 : null,
          "pickupMeasurementComments": addComment,
          "isPickupGrossWeight": grossDisable ? false : true,
          "isPickupTareWeight": tareDisable ? false : true

        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        if (response.data.isSuccess === true) {
          toast.success("Measurement saved")
        }
        else toast.error(response.data.message)
        getConsignmentDetails();
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  };

  const loading = () => {
    loaderService.showLoader();
    apiClient
      .post(
        UPDATE_LOADING_FLAG,
        {
          "consignmentId": consignmentdetails?.consignmentSourceDetails?.[0]?.consignmentId,
          "isLoadingDone": true,
          "loaderComments": addComment
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        response?.data?.isSuccess && toast.success(response?.data?.message);
        getConsignmentDetails();
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  };

  const getselectedHeapDetails = (heapList) => {
    setErrorMessage({ ...errorMessage, heapError: "" });
    let selectedHeapLocal = heapList.filter(heap => heap.isSelected)
    let unselectedHeapLocal = heapList.filter(heap => heap.isSelected === false)
    setSelectedHeap(selectedHeapLocal);
    let newArrayListLocal = [...newArrayList];
    //rbcbDetails?.concat(selectedHeap) ? rbcbDetails?.concat(selectedHeap) : selectedHeap;
    // let itemList = newArrayList.map(item =>{
    //    selectedHeapLocal.forEach(item1=>{
    //      if(item1.checkVal === item.checkVal){

    //      }
    //    })
    // })
    // console.log("in local logic")
    let newArrayListUpdated = newArrayListLocal.filter(item => {
      let present = true;
      selectedHeapLocal?.forEach(item1 => {
        if (item1.heapNumber === item.bundleId || item1.heapNumber === item.heapNumber) {
          present = false;
        }
      })
      return present;
    })

    newArrayListUpdated = newArrayListUpdated.filter(item => {
      let present = true;
      unselectedHeapLocal?.forEach(item1 => {
        if (item1.heapNumber === item.bundleId || item1.heapNumber === item.heapNumber) {
          present = false;
        }
      })
      return present;
    })
    newArrayListLocal = newArrayListUpdated?.concat(selectedHeapLocal) ? newArrayListUpdated?.concat(selectedHeapLocal) : selectedHeapLocal;
    setNewArrayList(newArrayListLocal);
  }

  const allocatedHeapDetails = (heapList) => {
    setErrorMessage({ ...errorMessage, heapError: "" })
    setSelectedHeap(heapList.filter(item => item.rbCbWeight).map(eachItem => ({
      ...eachItem,
      bundleId: eachItem.heapNumber,
      avgMoisture: eachItem.postChippingMoisture,
      totalMoisture: eachItem.postChippingMoisture,
      chippingOrderNo: eachItem.chippingOrderNo
    })));
    setNewArrayList(heapList.filter(item => item.rbCbWeight).map(eachItem => ({
      ...eachItem,
      bundleId: eachItem.heapNumber,
      avgMoisture: eachItem.postChippingMoisture,
      totalMoisture: eachItem.postChippingMoisture,
      chippingOrderNo: eachItem.chippingOrderNo
    })));
  }

  const onClickBundle = (onClose) => {
    handleLogModalOpen4(onClose);
  }

  const onDeliveryChallan = (e) => {
    e.preventDefault();
    if (!consignmentNoDetails.consignmentNo) {
      setErrorMessage({ ...errorMessage, consignmentNoError: "Please Enter Consignment Number" })
    }
    else {
      onCreate();
      // toCreateDeliveryChallan();
    }
  }

  const toCreateDeliveryChallan = (e) => {
    loaderService.showLoader();
    apiClient
      .post(CREATE_DELIVERY_CHALLAN,
        {
          "consignmentNo": consignmentNoDetails?.consignmentNo,
          "comment": addComment
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setCreateDeliveryChallan(response.data);
        loaderService.hideLoader();
        getConsignmentDetails();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  useEffect(() => {
    if (createDeliveryChallan) {
      if (createDeliveryChallan.isSuccess === true) {
        toast.success(createDeliveryChallan?.message)
        // handleLogModalOpen2();
      }
      else {
        toast.error(createDeliveryChallan?.message ? createDeliveryChallan?.message : "Error")
        // handleLogModalOpen();
      }
    }
  }, [createDeliveryChallan]);

  useEffect(() => {
    if (consignmentdetails?.pickupGrossWeight) {
      toleranceLimit();
    }
  }, [consignmentdetails?.pickupGrossWeight]);

  const toleranceLimit = () => {
    loaderService.showLoader();
    apiClient
      .post(
        GET_CONFIGURATION_VALUES,
        {
          "serviceType": "QualityToleranceLimit"
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        const configList = response?.data?.configurationDetailList || [];
        setGetTolerance(configList);

        let tolWeightLimit = 0;
        let avgMoistureLimit = 0;

        configList.forEach((tl) => {
          const appKey = tl.appKey?.toLowerCase();
          if (appKey === "weight") {
            tolWeightLimit = Number(tl.value) || 0;
          }
          if (appKey === "moisture") {
            avgMoistureLimit = Number(tl.value) || 0;
          }
        });

        let value = (consignmentdetails?.consignmentWeight) * 1000;
        let tolerance = (value * tolWeightLimit) / 100;
        let toleranceAvgMoisture = (consignmentdetails?.destinationTotalMoisture / 100) * avgMoistureLimit;

        const minValue = Number(((value - tolerance) * 100) / 100).toFixed(2);
        const maxValue = Number(((value + tolerance) * 100) / 100).toFixed(2);

        setMinAvgMoisture(consignmentdetails?.destinationTotalMoisture - toleranceAvgMoisture);
        setMaxAvgMoisture(consignmentdetails?.destinationTotalMoisture + toleranceAvgMoisture);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  };

  const getDownloadChallan = (action) => {
    loaderService.showLoader();
    apiClient
      .post(PRINT_DOWNLOAD_DATA,
        {
          "printDataByNumber": consignmentdetails?.delieryChallanNumber,
          "printDetailsType": "delivery_challan",
        },
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

            Accept: 'application/pdf'
          }
        }, null
      )
      .then((response) => {
        setDownloadDeliveryChallan(response.data);
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

        if (action === "download") {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Output.pdf`
          );
          document.body.appendChild(link);

          link.click();
          link.parentNode.removeChild(link);
        }
        if (action === "print") {
          let iframe = document.createElement('iframe');
          document.body.appendChild(iframe);
          iframe.style.display = 'none';
          iframe.src = url;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        }
        loaderService.hideLoader();
      }).catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }
  useEffect(() => {
    if (decoded.extension_URN) getStakeDetails();
  }, [decoded.extension_URN]);

  const getStakeDetails = () => {
    loaderService.showLoader()
    apiClient
      .post(GET_STAKEHOLDER_CATEGORY,
        {
          "urn": decoded.extension_URN,
          "type": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStakeholderDetails(response.data);
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()
      });
  }

  const onSendNotification = () => {
    handleConfirmOpen7();
  }

  const onConfirmSendNotification = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await sendChallanNotification();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen7(false);
      setIsApiCalled(false);
    }
  }

  const sendChallanNotification = () => {
    loaderService.showLoader()
    apiClient
      .post(SEND_PLANT_GATE_PASS_NOTIFICATION,
        {
          "challanNumber": consignmentdetails?.delieryChallanNumber,
          "consignmentNumber": consignmentdetails?.consignmentNo
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        if (response.data.isSuccess === true) {
          toast.success("Challan Notification Sent Successfully");
          getConsignmentDetails();
        }
        else toast.error(response.data.message)
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()
      });
  }

  const columns = [
    {
      field: 'heapNumber', headerName: 'Heap No.', width: 280,
      valueGetter: (params) => {
        return params.row.bundleId || params.row.heapNumber
      }
    },
    {
      field: 'arrivalMoisture', headerName: 'Average Moisture', width: 180,
      valueGetter: (params) => {
        return params?.row?.avgMoisture ? Number(params.row.avgMoisture)?.toFixed(2) : params.row.postChippingMoisture ? Number(params.row.postChippingMoisture)?.toFixed(2) : null
      }
    },
    {
      field: 'rbCbWeight', headerName: 'Pick-up Quantity(in MT)', width: 200,
      valueGetter: (params) => {
        return Number(params.row.rbCbWeight)?.toFixed(2)
      }
    },

  ];

  const bundleCol = [
    { field: 'bundleId', headerName: 'Bundle ID', flex: 1 },
    {
      field: 'moisture', headerName: 'Moisture', flex: 1,
      valueGetter: (params) => {
        return params?.row?.moisture ? Number(params.row.moisture) : params?.row?.avgMoisture ? Number(params.row.avgMoisture)?.toFixed(2) : params.row.postChippingMoisture ? Number(params.row.postChippingMoisture)?.toFixed(2) : null
      }
    },
    {
      field: 'rbCbWeight', headerName: 'Pick-up Quantity(in MT)', flex: 1,
      valueGetter: (params) => {
        return Number(params.row.rbCbWeight)?.toFixed(4)
      }
    },

  ];

  // const onConfirmSave = (e) => {
  //   handleConfirmClose();
  //   consignment_pickup_cb_save(false, false);
  //   // onSave(e);
  // }

  const onConfirmSave = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await consignment_pickup_cb_save(false, false);
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen(false);
      setIsApiCalled(false);
    }
  };

  const [acceptingInput, setAcceptingInput] = useState(false);
  const timeoutRef = useRef(null);

  // const handleKeyDown = (e) => {
  //   if (e.key === 'Backspace') {
  //     e.preventDefault();
  //   }
  //   if ((e.code === "" && e.key === "0") || e.key === "F7") {
  //     setAcceptingInput(true);
  //     if (timeoutRef.current) clearTimeout(timeoutRef.current);
  //     timeoutRef.current = setTimeout(() => {
  //       setAcceptingInput(false);
  //     }, 10000);
  //   }
  // };

  const handleKeyDown = (e) => {
    console.log("e.key", e.key)
    console.log("e.code", e.code)
    if (e.key === 'Backspace') {
      e.preventDefault();
    }
    // if ((e.code === "" && e.key === "0") || e.key === "F7") {
    // setAcceptingInput(true);
    // if (timeoutRef.current) clearTimeout(timeoutRef.current);
    // timeoutRef.current = setTimeout(() => {
    //  setAcceptingInput(false);
    //  }, 10000);
    //}
    if (e.code !== "" || ((/[0-9]$/.test(e.key) == false) && e.key !== ".")) {
      e.preventDefault();
    }
  };

  const onSaveButtonClick = (e) => {
    handleConfirmOpen();
  }

  // const onConfirmCreateDeliveryChallan = (e) => {
  //   handleConfirmClose2();
  //   toCreateDeliveryChallan();
  //   // onDeliveryChallan(e);
  // }

  const onConfirmCreateDeliveryChallan = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await toCreateDeliveryChallan();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen2(false);
      setIsApiCalled(false);
    }
  };

  const onCreate = (e) => {
    handleConfirmOpen2();
  }

  // const onConfirmStartTrip = (e) => {
  //   handleConfirmClose3();
  //   consignment_pickup_cb_save(true, true);
  //   // onStart(e);
  // }

  const onConfirmStartTrip = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await consignment_pickup_cb_save(true, true);
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen3(false);
      setIsApiCalled(false);
    }
  };

  const onStartDestinationTrip = (e) => {
    handleConfirmOpen3();

  }

  // const onConfirmSaveBundle = (e) => {
  //   handleConfirmClose4();
  //   consignment_pickup_cb_save(false, true);
  // }

  const onConfirmSaveBundle = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await consignment_pickup_cb_save(false, true);
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen4(false);
      setIsApiCalled(false);
    }
  };

  // const onConfirmSaveMeasurement = (e) => {
  //   handleConfirmClose5();
  //   consignment_pickup_save_measurement();
  // }

  const onConfirmSaveMeasurement = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await consignment_pickup_save_measurement();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen5(false);
      setIsApiCalled(false);
    }
  };

  // const onConfirmLoading = (e) => {
  //   handleConfirmClose6();
  //   loading();
  // }

  const onConfirmLoading = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await loading();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen6(false);
      setIsApiCalled(false);
    }
  };

  const onSave = (e) => {
    e.preventDefault();
    if (!consignmentNoDetails.consignmentNo) {
      setErrorMessage({ ...errorMessage, consignmentNoError: "Please Enter Consignment Number" })
    }
    // else if (errorMessage.totalWeightError !== '') {
    //   setErrorMessage({ ...errorMessage, totalWeightError: `Value must be within ${minimum} and ${maximum} ` });
    // }
    else if (newArrayList.length === 0) {
      setErrorMessage({ ...errorMessage, heapError: "Please select heap" });
    }
    else {
      onSaveButtonClick();
      // consignment_pickup_cb_save(false, false);
    }
  }

  const onSaveBundle = (e) => {
    e.preventDefault();
    // if (!consignmentNoDetails?.pickupTareWeight) {
    //   setErrorMessage({ ...errorMessage, pickupTareWeightError: "Please enter Tare weight" })
    // }
    if (consignmentdetails?.materialType === "ChipBamboo" && newArrayList?.length === 0) {
      setErrorMessage({ ...errorMessage, heapError: "Please select heap" });
      toast.error('Please select heap')
    }
    else if (consignmentdetails?.materialType === "RawBamboo" && selectedBundles?.length === 0) {
      setErrorMessage({ ...errorMessage, bundleError: "Please select bundle" });
      toast.error('Please select bundle')
    }
    // else if (!consignmentNoDetails?.pickupGrossWeight) {
    //   setErrorMessage({ ...errorMessage, pickupGrossWeightError: "Please enter Gross Weight " })
    // }
    // else if (!consignmentNoDetails?.pickupAvgChipSize) {
    //   setErrorMessage({ ...errorMessage, pickupAvgChipSizeError: "Please enter Average Chip Size" })
    // }
    // else if (!consignmentNoDetails?.totalMoisture) {
    //   setErrorMessage({ ...errorMessage, totalMoistureError: "Please enter Average Moisture" })
    // }
    // else if (!consignmentNoDetails?.pickupTareWeight) {
    //   setErrorMessage({ ...errorMessage, pickupTareWeightError: "Please enter Tare weight" })
    // }
    // else if (errorMessage.totalWeightError !== '') {
    //   setErrorMessage({ ...errorMessage, totalWeightError: `Value must be within ${minimum} and ${maximum} ` });
    // }
    else {
      handleConfirmOpen4();
      setErrorMessage({ ...errorMessage, heapError: "" });
      setErrorMessage({ ...errorMessage, bundleError: "" });
    }
  }

  const onMeasurement = () => {
    if (!consignmentdetails?.isLoadingDone && (!consignmentNoDetails?.pickupTareWeight || Number(consignmentNoDetails?.pickupTareWeight) === 0)) {
      setErrorMessage({ ...errorMessage, pickupTareWeightError: "Please enter Tare weight" })
    }
    else if (consignmentdetails?.isLoadingDone && (!consignmentNoDetails?.pickupGrossWeight || Number(consignmentNoDetails?.pickupGrossWeight) === 0)) {
      setErrorMessage({ ...errorMessage, pickupGrossWeightError: "Please enter Gross Weight " })
    }
    // else if (getTolerance.length > 0 && errorMessage.totalWeightError !== '') {
    //   setErrorMessage({ ...errorMessage, totalWeightError: `Value must be within ${minimum} and ${maximum} ` });
    // }
    else {
      handleConfirmOpen5();
    }
  }

  const onCompleteLoading = () => {
    handleConfirmOpen6();
  }

  const onStart = (e) => {
    e.preventDefault();

    // if ((consignmentNoDetails?.pickupTareWeight) && (consignmentNoDetails?.totalMoisture) && (consignmentNoDetails?.pickupAvgChipSize) && (consignmentNoDetails?.pickupGrossWeight) && (consignmentNoDetails?.pickupNetWeight) && (consignmentNoDetails?.odometerReading) && (consignmentNoDetails?.isHitInspectionChecklist != null) && (consignmentNoDetails?.isProperLashing != null) && (consignmentNoDetails?.isPayloadWithinCapacity != null) && (consignmentNoDetails?.isPayloadHeightExceedLimit != null) && (errorMessage?.totalWeightError === "") && newArrayList) {
    // else {
    if (!consignmentNoDetails?.odometerReading) {
      setErrorMessage({ ...errorMessage, odometerReadingError: "Please enter Odometer Start Reading" })
    }
    // else if (totalWeight > totalPickupWeight || totalWeight < totalPickupWeight) {
    //   setErrorMessage({ ...errorMessage, weightError: "Weight during pick up and heap selected weight should be same" })
    // }
    // else if (errorMessage.totalWeightError !== '') {
    //   setErrorMessage({ ...errorMessage, totalWeightError: `Value must be within ${minimum} and ${maximum} ` });
    // }
    // else if (newArrayList.length === 0) {
    //   setErrorMessage({ ...errorMessage, heapError: "Please select heap" });
    // }
    else if (consignmentNoDetails.isHitInspectionChecklist === null) {
      setErrorMessage({ ...errorMessage, isHitInspectionChecklistError: "Please select" });
    }
    else if (consignmentNoDetails?.isProperLashing === null) {
      setErrorMessage({ ...errorMessage, isProperLashingError: "Please select" });
    }
    else if (consignmentNoDetails?.isPayloadWithinCapacity === null) {
      setErrorMessage({ ...errorMessage, isPayloadWithinCapacityError: "Please select" });
    }
    else if (consignmentNoDetails?.isPayloadHeightExceedLimit === null) {
      setErrorMessage({ ...errorMessage, isPayloadHeightExceedLimitError: "Please select" });
    }
    else {
      onStartDestinationTrip(e);
      // consignment_pickup_cb_save(true, true);
      // console.log(newArrayList);
    }
    // }

  }

  const selectedCons = {
    sourceStakeholderType: consignmentdetails?.consignmentSourceDetails?.[0]?.sourceType,
    sourceStakeholderUrn: consignmentdetails?.consignmentSourceDetails?.[0]?.sourceStakeholderUrn,
    materialType: consignmentdetails?.materialType,
  }

  const handleSubmit = ({ bundles, pickupQty }) => {
    // setSelectedBundles(bundles);
    setSelectedBundles(bundles?.map(eachItem => ({
      id: eachItem?.id,
      heapNumber: eachItem?.bundleId,
      rbCbWeight: eachItem?.pickupQty,
      bundleId: eachItem?.bundleId,
      avgMoisture: eachItem?.moisture,
    })));
    setPickupQuantity(pickupQty);
    setErrorMessage({ ...errorMessage, bundleError: "" });
  };

  const goBack = () => {
    if (state?.pageName === "inventoryType") {
      navigate("/inventoryType", { state: { tabValue: state?.tabValue } });
    }
    else if (state?.pageName === 'consignmentPickupTracker') {
      navigate('/consignmentPickupTracker', { state: { tabValue: state?.tabValue } })
    }
    else {
      navigate(-1);
    }
  }

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT45</p>}
        <Typography variant="h4" gutterBottom>
          <Fab onClick={() => goBack()} size="small" aria-label="back" title='Back'>
            <KeyboardArrowLeftRounded />
          </Fab> Consignment Pick Up/Tracker
        </Typography>
        <Card>
          <CardContent>
            <Grid container spacing={1} direction="row" mt={1}>
              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Consignment No' type="text" value={consignmentdetails?.consignmentNo || ''} name="consignmentNo" disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Consignment Status' type="text" value={consignmentdetails?.consignmentStatus || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label="Transporter URN" type="text" value={consignmentdetails?.consignmentSourceUrn || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Transporter Name' type="text" value={consignmentdetails?.consignmentOwnerName || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Transporter Contact' type="text" value={consignmentdetails?.consignmentOwnerContactNo || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Pick-Up Location URN' type="text" value={consignmentsource?.sourceStakeholderUrn || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Pick-Up Location Name' type="text" value={consignmentsource?.sourceLocationName || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Pick-Up Location Address' type="text" value={consignmentsource?.sourceLocationAddress || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='SO' type="text" value={consignmentsource?.sourceStakeholderPo || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Schedule Line Number' type="text" value={consignmentsource?.scheduleLineNumber || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Schedule Delivery Date' type="text" value={consignmentdetails?.scheduleDeliveryTimestamp && Moment(consignmentdetails?.scheduleDeliveryTimestamp).format('DD/MM/YYYY') || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Schedule Pick-Up Date' type="text" value={consignmentdetails?.consignmentPickDate && Moment(consignmentdetails?.consignmentPickDate).format('DD/MM/YYYY') || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Schedule Consignment Weight(in KG)' type="text" value={Number((consignmentdetails?.consignmentWeight) * 1000)?.toFixed(4) || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Delivery Location Name' type="text" value={consignmentdetails?.consignmentDestinationLocationName || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Delivery Location Address' type="text" value={consignmentdetails?.consignmentDestinationLocationAddress || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Type of Inventory' type="text" value={consignmentdetails?.materialType || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Type Of Loading(FTL/LTL)' type="text" value={consignmentdetails?.typeOfLoading || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Driver Name' type="text" value={consignmentdetails?.driverName || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Driver License No.' type="text" value={consignmentdetails?.driverLicenseNo || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Driver Contact' type="text" value={consignmentdetails?.driverContact || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Vehicle Registration' type="text" value={consignmentdetails?.vehicleRegNo || ''} disabled />
                  </Grid>
                  {/* <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Vehicle Capacity(in MT)' type="text" value={consignmentdetails?.vehicleCapacity || ''} disabled />
                  </Grid> */}
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Delivery Location URN' type="text" value={consignmentdetails?.consignmentDestinationStakeholderUrn || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField
                      fullWidth
                      required
                      error={errorMessage.pickupTareWeightError}
                      helperText={errorMessage.pickupTareWeightError}
                      size="small"
                      label="Tare weight measured @LLE(in KG)"
                      type="number"
                      onFocus={handleNumberFieldFocus}
                      name="pickupTareWeight"
                      inputRef={tareRef}
                      disabled={
                        !isWeighbridgeOperatorRole ||
                        (isWeighbridgeOperatorRole &&
                          consignmentdetails?.isPickupBundlesSelected &&
                          consignmentdetails?.isLoadingDone)
                      }
                      value={
                        consignmentNoDetails?.pickupTareWeight &&
                          (!isWeighbridgeOperatorRole ||
                            (isWeighbridgeOperatorRole &&
                              consignmentdetails?.isPickupBundlesSelected &&
                              consignmentdetails?.isLoadingDone))
                          ? Number(consignmentNoDetails?.pickupTareWeight)?.toFixed(4)
                          : consignmentNoDetails?.pickupTareWeight
                      }
                      onChange={handleChange}
                      inputProps={{ maxLength: 10 }}
                      onKeyDown={(e) => {
                        if (getLocalStorageItem("role") === PIT_ROLES?.PitWeighbridgeOperator) {
                          handleKeyDown(e);
                        } else {
                          if (e.key === "e" || e.key === "E" || e.key === "+" || e.key === "-") e.preventDefault();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Average Moisture during the pickup'
                      type="number"
                      onFocus={handleNumberFieldFocus}
                      name="totalMoisture"
                      disabled={!isWeighbridgeOperatorRole || (isWeighbridgeOperatorRole && consignmentdetails?.isPickupBundlesSelected && !consignmentdetails?.isLoadingDone)}
                      value={(consignmentdetails?.totalMoisture && (!isWeighbridgeOperatorRole || (isWeighbridgeOperatorRole && consignmentdetails?.isPickupBundlesSelected && !consignmentdetails?.isLoadingDone)) ? Number(consignmentdetails?.totalMoisture)?.toFixed(4) : consignmentdetails?.totalMoisture) || ''}
                      // value={consignmentdetails?.isTripStarted === true || consignmentdetails?.isLoadingDone === true || (role1 && consignmentdetails?.loadingCompleteDate == null) || role2 || stakeholderDetails?.category === 'Transporter' ? Number(consignmentdetails?.totalMoisture)?.toFixed(4) || '' : consignmentdetails?.totalMoisture || ''}
                      onChange={(e) => handleChange(e)}
                      // InputProps={{ maxLength: 6 }}
                      required
                      error={errorMessage.totalMoistureError}
                      helperText={errorMessage.totalMoistureError}
                      onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                    />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Gross weight measured @LLE(in KG)"
                      type="number"
                      onFocus={handleNumberFieldFocus}
                      required
                      error={errorMessage.pickupGrossWeightError}
                      helperText={errorMessage.pickupGrossWeightError}
                      name="pickupGrossWeight"
                      inputRef={grossRef}
                      disabled={
                        !isWeighbridgeOperatorRole ||
                        (isWeighbridgeOperatorRole &&
                          consignmentdetails?.isPickupBundlesSelected &&
                          !consignmentdetails?.isLoadingDone)
                      }
                      value={
                        consignmentNoDetails?.pickupGrossWeight &&
                          (!isWeighbridgeOperatorRole ||
                            (isWeighbridgeOperatorRole &&
                              consignmentdetails?.isPickupBundlesSelected &&
                              !consignmentdetails?.isLoadingDone))
                          ? Number(consignmentNoDetails?.pickupGrossWeight)?.toFixed(4)
                          : consignmentNoDetails?.pickupGrossWeight
                      }
                      onChange={handleChange}
                      inputProps={{ maxLength: 10 }}
                      onKeyDown={(e) => {
                        if (getLocalStorageItem("role") === PIT_ROLES?.PitWeighbridgeOperator) {
                          handleKeyDown(e);
                        } else {
                          if (e.key === "e" || e.key === "E" || e.key === "+" || e.key === "-") e.preventDefault();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small"
                      label='Weight during pickup(in KG)'
                      required
                      error={errorMessage.totalWeightError}
                      helperText={errorMessage.totalWeightError}
                      type="number"
                      onFocus={handleNumberFieldFocus}
                      name="pickupNetWeight"
                      disabled
                      value={pickupNetWeight ? Number(pickupNetWeight)?.toFixed(4) : ""} />
                  </Grid>
                  {/* <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small"
                      label='Weight during pickup from Bundle selection(in KG)'
                      type="number"
                      onFocus={handleNumberFieldFocus}
                      name="totalWeight"
                      disabled
                      value={consignmentdetails?.consignmentStatus !== "Created" ? Number((consignmentdetails?.totalWeight) * 1000)?.toFixed(4) : consignmentdetails?.materialType === "RawBamboo" ? Number((pickupQuantity) * 1000)?.toFixed(4) : Number(totalPickupWeight * 1000)?.toFixed(4)}
                    // onChange={(e) => handleChange(e)} 
                    />
                  </Grid> */}
                  {stakeholderDetails?.category === 'Transporter' && <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small"
                      label='Odometer Start Reading'
                      required
                      error={errorMessage.odometerReadingError}
                      helperText={errorMessage.odometerReadingError}
                      type="number"
                      onFocus={handleNumberFieldFocus}
                      name="odometerReading"
                      hidden={stakeholderDetails?.category === 'LLE'}
                      disabled={consignmentdetails?.isTripStarted === true || (role1 && consignmentdetails?.loadingCompleteDate == null) || role2}
                      value={consignmentNoDetails?.odometerReading || ''}
                      onChange={(e) => handleChange(e)}
                      onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                    // InputProps={{ maxLength: 6 }}
                    />
                  </Grid>}
                  <Grid item xs={12} lg={4} hidden={consignmentdetails?.materialType === "RawBamboo"}>
                    <Button disabled={consignmentdetails?.isPickupBundlesSelected || stakeholderDetails?.category === "Transporter"} onClick={onClickBundle} heapSubmitCallbackFunction={selectedHeap}>Select Heap</Button>
                    <Typography sx={{ color: 'red' }}>
                      {errorMessage.heapError}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} lg={4} hidden={consignmentdetails?.materialType === "ChipBamboo"}>
                    <Button disabled={consignmentdetails?.isPickupBundlesSelected || stakeholderDetails?.category === "Transporter"} onClick={() => setOpen(true)}>Select Bundle</Button>
                    <Typography sx={{ color: 'red' }}>
                      {errorMessage.bundleError}
                    </Typography>
                  </Grid>
                  <Divider sx={{
                    width: '105%',
                    bgcolor: 'black',
                    marginTop: '3vh'
                  }} mt={2} />
                  <Grid item xs={12} lg={12}>

                    {selectedBundles.length !== 0 &&
                      <Box style={{ height: 300, width: '100%' }}>
                        {
                          selectedBundles &&
                          <DataGrid rows={selectedBundles}
                            columns={bundleCol}
                            pageSize={10}
                            // getRowId={(row) => row.bundleId}
                            components={{ Toolbar: QuickSearchToolbar }}
                          />
                        }
                      </Box>
                    }
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    {newArrayList.length !== 0 &&
                      <Box style={{ height: 300, width: '100%' }}>
                        {
                          newArrayList &&
                          <DataGrid rows={newArrayList}
                            columns={columns}
                            pageSize={10}
                            // getRowId={(row) => row.bundleId}
                            components={{ Toolbar: QuickSearchToolbar }}
                          />
                        }
                      </Box>
                    }
                  </Grid>
                  <Divider sx={{
                    width: '105%',
                    bgcolor: 'black',
                    marginTop: '3vh'
                  }} mt={2} hidden={stakeholderDetails?.category === 'LLE'} />
                  {stakeholderDetails?.category === 'Transporter' &&
                    <>
                      <Grid item xs={12} lg={6} hidden={stakeholderDetails?.category === 'LLE'}>
                        <FormControl fullWidth required error={errorMessage.isHitInspectionChecklistError}>
                          <FormLabel id="demo-row-radio-buttons-group-label">Truck Covered</FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                          >
                            <FormControlLabel name="isHitInspectionChecklist" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isHitInspectionChecklist === true} onChange={(e) => radioChange(e, true)} control={<Radio />} label="Yes" />
                            <FormControlLabel name="isHitInspectionChecklist" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isHitInspectionChecklist === false} onChange={(e) => radioChange(e, false)} control={<Radio />} label="No" />
                          </RadioGroup>
                          <FormHelperText sx={{ color: 'red' }}>{errorMessage.isHitInspectionChecklistError}</FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={6} hidden={stakeholderDetails?.category === 'LLE'}>
                        <FormControl fullWidth required error={errorMessage.isProperLashingError}>
                          <FormLabel id="demo-row-radio-buttons-group-label">Proper Lashing</FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                          >
                            <FormControlLabel name="isProperLashing" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isProperLashing === true} onChange={(e) => radioChange(e, true)} control={<Radio />} label="Yes" />
                            <FormControlLabel name="isProperLashing" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isProperLashing === false} onChange={(e) => radioChange(e, false)} control={<Radio />} label="No" />
                          </RadioGroup>
                          <FormHelperText sx={{ color: 'red' }}>{errorMessage.isProperLashingError}</FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={6} hidden={stakeholderDetails?.category === 'LLE'}>
                        <FormControl fullWidth required error={errorMessage.isPayloadWithinCapacityError}>
                          <FormLabel id="demo-row-radio-buttons-group-label">Payload Within Capacity Limits</FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                          >
                            <FormControlLabel name="isPayloadWithinCapacity" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isPayloadWithinCapacity === true} onChange={(e) => radioChange(e, true)} control={<Radio />} label="Yes" />
                            <FormControlLabel name="isPayloadWithinCapacity" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isPayloadWithinCapacity === false}
                              onChange={(e) => radioChange(e, false)} control={<Radio />} label="No" />
                          </RadioGroup>
                          <FormHelperText sx={{ color: 'red' }}>{errorMessage.isPayloadWithinCapacityError}</FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={6} hidden={stakeholderDetails?.category === 'LLE'}>
                        <FormControl fullWidth required error={errorMessage.isPayloadHeightExceedLimitError}>
                          <FormLabel id="demo-row-radio-buttons-group-label">Payload Height Exceeding Limit</FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                          >
                            <FormControlLabel name="isPayloadHeightExceedLimit" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isPayloadHeightExceedLimit === true}
                              onChange={(e) => radioChange(e, true)} control={<Radio />} label="Yes" />
                            <FormControlLabel name="isPayloadHeightExceedLimit" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isPayloadHeightExceedLimit === false}
                              onChange={(e) => radioChange(e, false)} control={<Radio />} label="No" />
                          </RadioGroup>
                          <FormHelperText sx={{ color: 'red' }}>{errorMessage.isPayloadHeightExceedLimitError}</FormHelperText>
                        </FormControl>
                      </Grid>
                    </>}
                  <Grid item xs={12} lg={6}>
                    <TextField fullWidth
                      autoComplete="off"
                      id="outlined-multiline-static"
                      label="Comments"
                      multiline
                      rows={4}
                      name="pickupComments"
                      onChange={(e) => onTextValueChange(e)}
                      value={addComment}
                      disabled={consignmentdetails?.isTripStarted === true}
                      sx={{ paddingRight: '15%' }}
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '10%' }}>
                      <Badge bg={`${addComment?.length > characterLimit ? 'danger' : 'primary'}`}>{addComment?.length}/{characterLimit}</Badge>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Box style={{ height: 300, width: '100%' }}>
                      <DataGrid
                        rows={commentRows?.filter(item => item.isValueThere)}
                        columns={commentColumns}
                        pageSize={10}
                        getRowHeight={() => 'auto'}
                        getRowId={(row) => row.action}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
          {(localStorage.getItem('role') == PIT_ROLES.PitScmUser || stakeholderDetails) &&
            <>
              {consignmentdetails?.isTripStarted === true || !consignmentdetails?.isPickupMeasurementDone ? null :
                <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" hidden={stakeholderDetails?.category !== 'Transporter' || consignmentdetails?.isTripStarted === true} onClick={(e) => onStart(e)}>Start Trip To Destination</Button>
              }
              {consignmentdetails?.isPickupMeasurementDone && stakeholderDetails?.category === "LLE" && !consignmentdetails?.delieryChallanNumber && <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onDeliveryChallan(e)}>Create Delivery Challan</Button>}
              {consignmentdetails?.consignmentStatus === "Created" && (stakeholderDetails?.category === "LLE" || stakeholderDetails?.category === "ISO") && <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onSaveBundle(e)}>Save</Button>}
              {consignmentdetails?.delieryChallanNumber &&
                <>
                  <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={() => getDownloadChallan("download")}>Download</Button>
                  <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={() => getDownloadChallan("print")}>Print</Button>
                </>
              }
            </>
          }

          <Button sx={{ minWidth: 100, ml: 1 }} disabled={!stakeholderDetails || consignmentdetails?.isTripStarted !== true || consignmentdetails?.isChallanNotificationSent === true} hidden={consignmentdetails?.materialType !== "ChipBamboo" && consignmentdetails?.consignmentDestinationType !== "Plant"} variant="contained" onClick={() => onSendNotification()}>Vehicle Arrived at Destination</Button>

          {isWeighbridgeOperatorRole && !consignmentdetails?.isPickupMeasurementDone && <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" disabled={consignmentdetails?.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs?.length === 0 && isWeighbridgeOperatorRole} onClick={onMeasurement}>Save</Button>}
          {localStorage.getItem('role') === PIT_ROLES.Loader && consignmentdetails?.consignmentStatus === "PickUpTareWeightMeasured" && <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" disabled={consignmentdetails?.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs?.length === 0 && getLocalStorageItem('role') === PIT_ROLES?.Loader} onClick={onCompleteLoading}>Complete Loading</Button>}

        </Box>
      </Container>

      <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmSave} onClose={handleConfirmClose} action="Save" />
      <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmCreateDeliveryChallan} onClose={handleConfirmClose2} action="Create Delivery Challan" />
      <ConfirmationPopover onOpen={confirmOpen3} onConfirm={onConfirmStartTrip} onClose={handleConfirmClose3} action="Start Trip To Destination" />
      <ConfirmationPopover onOpen={confirmOpen4} onConfirm={onConfirmSaveBundle} onClose={handleConfirmClose4} action="Save" />
      <ConfirmationPopover onOpen={confirmOpen5} onConfirm={onConfirmSaveMeasurement} onClose={handleConfirmClose5} action="Save" />
      <ConfirmationPopover onOpen={confirmOpen6} onConfirm={onConfirmLoading} onClose={handleConfirmClose6} action="Complete Loading" />
      <ConfirmationPopover onOpen={confirmOpen7} onConfirm={onConfirmSendNotification} onClose={handleConfirmClose7} action="Submit" />

      <Dialog maxWidth='md' fullWidth open={logModalOpen4}>
        <DialogContent>
          <HeapPopOver selectedHeap={selectedHeap} computed={computed} setComputed={setComputed} pickupQuantity={pickupQuantity} setPickupQuantity={setPickupQuantity} newArrayList={newArrayList} vehicleCapacity={consignmentdetails?.vehicleCapacity} handleLogModalClose={handleLogModalClose4} heapSubmitCallbackFunction={getselectedHeapDetails} allocateHeapFunction={allocatedHeapDetails} scheduledWeight={consignmentdetails?.scheduledWeight} pickupUrnType={consignmentdetails?.consignmentSourceDetails?.[0]} />
        </DialogContent>
      </Dialog>
      <RBBundleSelection open={open} selectedCons={selectedCons} pickupQuantity={consignmentdetails?.consignmentWeight} setPickupQuantity={setPickupQuantity} onClose={() => setOpen(false)} onSubmit={handleSubmit} selectedBundles={selectedBundles} />

    </>
  )
}
export default LlePickUpDetails;
